import {
  RECOMMEND_BANNER_REQUEST,
  RECOMMEND_WEEK_HOTS_REQUEST,
  RECOMMEND_RECOMMEND_REQUEST,
  RECOMMEND_GROUP_REQUEST,
  GUESS_LIKES_REQUEST,
  GET_SOFTINFOS_REQUEST,
  GET_SOFTINFOS_BY_V_REQUEST,
  RECO_TOP_CONTENTS_REQUEST,
  RECO_RECOMMEND_CONTENTS_REQUEST,
  RECOMMEND_OTHER_TOP_REQUEST,
} from '../constants/recommend';

// 6.6 首页改版 card banner
export const getRecoBanner = param => ({
  type: RECO_TOP_CONTENTS_REQUEST,
  ...param,
});
// 6.6 首页改版 card list
export const getRecoRecommend = param => ({
  type: RECO_RECOMMEND_CONTENTS_REQUEST,
  ...param,
});

export const getRecommendBanner = param => ({
  type: RECOMMEND_BANNER_REQUEST,
  ...param,
});

export const getRecommendWeekHot = param => ({
  type: RECOMMEND_WEEK_HOTS_REQUEST,
  ...param,
});

export const getRecommendReco = param => ({
  type: RECOMMEND_RECOMMEND_REQUEST,
  ...param,
});

export const getRecommendGroup = param => ({
  type: RECOMMEND_GROUP_REQUEST,
  ...param,
});

export const getGuessLikes = param => ({
  type: GUESS_LIKES_REQUEST,
  ...param,
});

// 8.0 新增
export const getRecoOtherTop = param => ({
  type: RECOMMEND_OTHER_TOP_REQUEST,
  ...param,
});

export const getSoftInfos = param => ({
  type: GET_SOFTINFOS_REQUEST,
  ...param,
});

// 8.3 新增
export const getSoftInfosByVersion = param => ({
  type: GET_SOFTINFOS_BY_V_REQUEST,
  ...param,
});
